var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-container" },
    [
      _c(
        "div",
        { staticClass: "manager-header" },
        [
          _c("sui-container", [
            _c(
              "div",
              { staticClass: "manager" },
              [
                _c(
                  "sui-header",
                  { tag: "h3", staticStyle: { "font-weight": "lighter" } },
                  [_vm._v("Firm Models")]
                ),
                _c(
                  "div",
                  { staticClass: "search-filter" },
                  [
                    _c("sui-dropdown", {
                      staticClass: "firm-dropdown-menu",
                      attrs: {
                        placeholder: "Firm",
                        text: "Firm",
                        selection: "",
                        options: _vm.firmsOptions,
                      },
                      model: {
                        value: _vm.firm,
                        callback: function ($$v) {
                          _vm.firm = $$v
                        },
                        expression: "firm",
                      },
                    }),
                    _c("sui-input", {
                      attrs: {
                        placeholder: "Search",
                        icon: "search",
                        "icon-position": "left",
                      },
                      model: {
                        value: _vm.searchPhrase,
                        callback: function ($$v) {
                          _vm.searchPhrase = $$v
                        },
                        expression: "searchPhrase",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "actions" },
                  [
                    _c("sui-button", {
                      attrs: {
                        basic: "",
                        size: "tiny",
                        color: "grey",
                        content: "New Firm Model",
                      },
                      on: { click: _vm.handleAdd },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "sui-container",
        { staticClass: "model-list" },
        [
          _c("ModelList", {
            attrs: { models: _vm.models },
            on: {
              handleEdit: _vm.handleEdit,
              showDeleteWarning: _vm.showDeleteWarning,
            },
          }),
          _c("Modal", {
            attrs: {
              open: _vm.isOpen,
              cancel: _vm.toggleModal,
              modalAction: _vm.modalAction,
              models: _vm.modelOptions,
            },
            on: { add: _vm.addModel, edit: _vm.editModel },
          }),
          _c("DeleteWarning", {
            ref: "deleteWarningModal",
            on: { handleDelete: _vm.deleteModel },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }